import React, { useEffect, useState } from "react";
import BestSelling from "../../component/bestselling/BestSelling";
import FeatureCategory from "../../component/featuredcategory/FeatureCategory";

import Subscribe from "../../component/sunscribe/Subscribe";
import Preoder from "../../component/preorder/Preoder";
import Delevery from "../../component/delevery/Delevery";
import homeModel from "../../model/home.model";
import RecentPurchase from "../../component/recentlypurchsed/RecentPurchase";
import OrderCard from "../../component/odercard/OrderCard";
import HomeBanner from "../../component/HomeBanner/HomeBanner";
import { IoLogoWhatsapp } from "react-icons/io";
import { useLocation } from "react-router-dom";
import Blank from "../../component/blank/Blank";

const Home = () => {
  const [datalist, Datalist] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bannerlist, setBannerList] = useState();

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  const GetData = async () => {
    setLoading(true);
    homeModel
      .Get()
      .then((response) => {
        Datalist(response?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const GetBanners = async () => {
    homeModel
      .GetBanner()
      .then((response) => {
        setBannerList(response?.data?.data);
      })
      .catch((error) => {
        console.log("error",error)
      });
  };
  useEffect(() => {
    GetData();
    GetBanners();
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("showOrderPopup") === "true") {
      setShowPopup(true);
      sessionStorage.removeItem("showOrderPopup");
    }
  }, []);

  const openWhatsApp = () => {
  const phoneNumber = "917411672999";
  const message = encodeURIComponent("Hello! I'm reaching out via your website.");
  const isMobile = /iPhone|Android|iPad|iPod/i.test(navigator.userAgent);

  const whatsappURL = isMobile
    ? `https://wa.me/${phoneNumber}?text=${message}`
    : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  window.open(whatsappURL, "_blank");
};
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  return (
    <div className="flex flex-col relative overflow-x-hidden bg-Background5">
  {/* WhatsApp Icon */}
  <div
    className="p-3 bg-textColor text-white text-5xl rounded-full fixed bottom-6 left-6 z-50 cursor-pointer"
    onClick={openWhatsApp}
  >
    <IoLogoWhatsapp />
  </div>

  {/* Home Banner */}
  {loading ? (
    <div className="m-4 h-64 skeleton rounded-lg" />
  ) : (
    <HomeBanner bannerlist={bannerlist} />
  )}

  {/* Best Selling Section */}
  {loading ? (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="h-40 skeleton rounded-xl" />
      ))}
    </div>
  ) : (
    <BestSelling item={datalist?.icons} loading={loading} />
  )}

  {/* Feature Category */}
  {loading ? (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 p-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="h-24 skeleton rounded-lg" />
      ))}
    </div>
  ) : (
    <FeatureCategory item={datalist?.featured_this_week} />
  )}

  {/* Recent Purchase */}
  {loading ? (
    <div className="p-4 space-y-3">
      {[...Array(2)].map((_, i) => (
        <div key={i} className="h-20 skeleton rounded-lg" />
      ))}
    </div>
  ) : (
    <RecentPurchase datalist={datalist?.recently_purchased} />
  )}

 
  <Subscribe />
  <Preoder />
  <Delevery />

 
  {showPopup && <OrderCard setShowPopup={setShowPopup} />}

  <Blank />
</div>
  );
};

export default Home;
